import { useEffect, useRef } from 'react'

export default function VideoTile({
  stream,
  label,
  muted = false,
  isMain = false,
  isLocal = false,
  empty = false,
  emptyMessage = '',
}) {
  const videoRef = useRef(null)

  useEffect(() => {
    const el = videoRef.current
    if (!el) return

    if (stream) {
      // Always attach + play whenever stream changes, regardless of empty flag.
      // This avoids a race where callConnected (which drives empty=false) flips
      // in a different render cycle than the stream itself arrives.
      if (el.srcObject !== stream) {
        el.srcObject = stream
      }
      const playPromise = el.play()
      if (playPromise !== undefined) {
        playPromise.catch((err) => {
          if (err.name !== 'AbortError') {
            console.warn('[VideoTile] play() failed:', err.name, err.message)
          }
        })
      }
    } else {
      el.srcObject = null
    }

    return () => {
      // Only null srcObject on actual unmount, not re-renders
      if (!document.contains(el)) {
        el.srcObject = null
      }
    }
  }, [stream])

  return (
    <div className={`relative w-full bg-obsidian-900 ${isMain ? 'aspect-video' : 'h-full'} overflow-hidden`}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted={muted}
        // FIX: isLocal mirrors the feed (user expects to see their own reflection);
        // remote video is NOT mirrored. Original had conflicting classes on both.
        className={`w-full h-full object-cover ${isLocal ? 'scale-x-[-1]' : ''}`}
      />

      {empty && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-obsidian-900">
          <div className="text-2xl mb-2 opacity-20">{isMain ? '👤' : '📷'}</div>
          {!isLocal && (
            <p className="text-ivory-300/30 text-xs text-center px-2 leading-relaxed">{emptyMessage}</p>
          )}
        </div>
      )}

      {!empty && (
        <div className="absolute bottom-1.5 left-2">
          <span className="text-[10px] text-ivory-300/60 bg-obsidian-900/70 px-1.5 py-0.5 rounded font-mono">
            {label}
          </span>
        </div>
      )}
    </div>
  )
}
